import { useMutation } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import { Patient } from './usePatient'

interface VerifyPatientDataResponse {
  patient: Patient
}

interface VerifyPatientDataVars extends Partial<Omit<Patient, 'sites'>> {}

const useVerifyPatientData = () => {
  const siteId = useCurrentSite()?.id

  return useMutation(
    ({
      firstName,
      lastName,
      dateOfBirth,
      cellPhoneLocal,
    }: VerifyPatientDataVars) => {
      const url = `/impacts/patients/verify_patient`
      return request
        .post<VerifyPatientDataResponse>(url, {
          siteIds: [siteId],
          firstName: firstName,
          lastName: lastName,
          dateOfBirth: dateOfBirth,
          cellPhoneLocal: cellPhoneLocal,
        })
        .then((r) => {
          return r.data
        })
    },
  )
}

export default useVerifyPatientData
